import styles from './styles.module.css';

type Props = {
  text: string;
};

const FormTextSuccess = ({ text }: Props) => {
  return (
    <div className={styles.formTextSuccessBox}>
      <i className="totem-icon totem-icon-check-circle" />
      <p className={styles.formTextSuccessText}> {text} </p>
    </div>
  );
};

export default FormTextSuccess;
